export default __webpack_public_path__ + "static/media/add-file-icon.0d5cc96c.svg";